import { render, staticRenderFns } from "./BidPrebidComponent.vue?vue&type=template&id=17231c52"
import script from "./BidPrebidComponent.vue?vue&type=script&lang=js"
export * from "./BidPrebidComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports